import { render, staticRenderFns } from "./DxViewWorkOrderForm.vue?vue&type=template&id=58d2bd7c&"
import script from "./DxViewWorkOrderForm.vue?vue&type=script&lang=js&"
export * from "./DxViewWorkOrderForm.vue?vue&type=script&lang=js&"
import style0 from "./DxViewWorkOrderForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports